import Filter from '../../controllers/filter';
import autoSchedulingPatchesModule from '../../autoScheduling';

export default instance => {
  instance.attachEvent('onAfterTaskAdd', (id, task) => {
    Filter.onAfterTaskAdd(id, task);
    autoSchedulingPatchesModule.checkTimelineDates(task);
  });
};
